import { createMemoryHistory, createRouter as createVueRouter, createWebHistory } from 'vue-router';

import { ROUTE_NAMES } from '@/router/route-names';

export function createRouter() {
  return createVueRouter({
    history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
    routes: [
      {
        path: '/',
        name: 'MainPage',
        component: () => import('@/pages/home-page.vue'),
        meta: { mnemonicCode: 'Main' },
      },
      {
        path: '/stores',
        name: 'Stores',
        component: () => import('@/pages/stores.vue'),
        meta: { mnemonicCode: 'Stores' },
      },
      {
        path: '/delivery',
        name: 'Delivery',
        component: () => import('@/pages/info/delivery.vue'),
        meta: { mnemonicCode: 'ServiceLevel' },
      },
      {
        path: '/gift_card',
        name: 'GiftCard',
        component: () => import('@/pages/info/gift_card.vue'),
        meta: { mnemonicCode: 'Giftcard' },
      },
      {
        path: '/payment',
        name: 'Payment',
        component: () => import('@/pages/info/payment.vue'),
        meta: { mnemonicCode: 'ServiceLevel' },
      },
      {
        path: '/contacts',
        name: 'Contacts',
        component: () => import('@/pages/info/contacts.vue'),
        meta: { mnemonicCode: 'Contacts' },
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/pages/info/about.vue'),
        meta: { mnemonicCode: 'Other' },
      },
      {
        path: '/razmery_odezhdy',
        name: 'Sizes',
        component: () => import('@/pages/info/sizes.vue'),
        meta: { mnemonicCode: 'Other' },
      },
      {
        path: '/obmen_i_vozvrat',
        name: 'ExchangeAndReturns',
        component: () => import('@/pages/info/obmen_i_vozvrat.vue'),
        meta: { mnemonicCode: 'Refund' },
      },
      {
        path: '/voprosi_i_otveti',
        name: 'FAQ',
        component: () => import('@/pages/info/faq.vue'),
        meta: { mnemonicCode: 'Other' },
      },
      {
        path: '/fun-club',
        name: 'FunClub',
        component: () => import('@/pages/info/club.vue'),
        meta: { mnemonicCode: 'Clubpro' },
      },
      {
        path: '/news',
        name: 'News',
        component: () => import('@/pages/news.vue'),
        meta: { mnemonicCode: 'News' },
      },
      {
        path: '/news/:id',
        name: 'Publication',
        component: () => import('@/pages/publication.vue'),
        meta: { mnemonicCode: 'News' },
      },
      {
        path: '/catalog',
        name: 'Search',
        component: () => import('@/pages/search.vue'),
        meta: { mnemonicCode: 'SearchResults' },
      },
      {
        path: '/catalog/:id',
        name: 'Catalog',
        component: () => import('@/pages/catalog.vue'),
        meta: { mnemonicCode: 'CatalogTree' },
      },
      {
        path: '/catalog/:id+',
        name: 'Category',
        component: () => import('@/pages/category/category.vue'),
        meta: { mnemonicCode: 'Catalog' },
      },
      {
        path: '/product/:id',
        name: ROUTE_NAMES.Product,
        component: () => import('@/pages/product.vue'),
        meta: { mnemonicCode: 'Product' },
      },
      {
        path: '/checkout',
        name: ROUTE_NAMES.Checkout,
        component: () => import('@/pages/checkout.vue'),
        meta: { mnemonicCode: 'Checkout' },
      },
      {
        path: '/thankyoupage',
        name: ROUTE_NAMES.TYP,
        component: () => import('@/pages/thankyou.vue'),
        meta: { mnemonicCode: 'ThankYou' },
      },
      {
        path: '/account',
        component: () => import('@/pages/account/account.vue'),
        children: [
          {
            path: '',
            name: ROUTE_NAMES.AccountProfile,
            component: () => import('@/pages/account/account-profile.vue'),
            meta: { mnemonicCode: 'Personal' },
          },
          {
            path: 'club',
            name: 'AccountClub',
            component: () => import('@/pages/account/account-club.vue'),
            meta: { mnemonicCode: 'Bonuses' },
          },
          {
            path: 'orders',
            name: 'AccountOrders',
            component: () => import('@/pages/account/orders.vue'),
            meta: { mnemonicCode: 'Orders' },
          },
          {
            path: 'addresses',
            name: 'AccountAddresses',
            component: () => import('@/pages/account/account-addresses.vue'),
            meta: { mnemonicCode: 'AddressesList' },
          },
          {
            path: 'favorites',
            name: 'AccountFavorites',
            component: () => import('@/pages/account/favorites.vue'),
            meta: { mnemonicCode: 'WishList' },
          },
          {
            path: 'notifications',
            name: 'AccountPromotions',
            component: () => import('@/pages/account/notifications-page.vue'),
            meta: { mnemonicCode: 'Notifications' },
          },
          {
            path: 'subscribes',
            name: 'AccountSubscribes',
            component: () => import('@/pages/account/account-subscribes.vue'),
            meta: { mnemonicCode: 'Subscriptions' },
          },
          {
            path: 'block',
            name: 'AccountBlock',
            component: () => import('@/pages/account/account-block.vue'),
            meta: { mnemonicCode: ROUTE_NAMES.AccountBlock },
          },
        ],
      },
      {
        path: '/clp/:id',
        name: ROUTE_NAMES.ContentLandingPages,
        component: () => import('@/pages/content-landing-pages.vue'),
        meta: { mnemonicCode: ROUTE_NAMES.ContentLandingPages },
      },
      // Статические страницы
      ...['/public_ofert', '/agreement', '/club_rules', '/content_rules', '/confidentiality', '/terms', '/recommendation_rules'].map((path) => ({
        path,
        name: path,
        component: () => import('@/pages/static_page.vue'),
      })),
    ],
  });
}
